import { Copy } from "lucide-react";
import { cx } from "class-variance-authority";

import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

export const truncate = (str: string, maxLength: number) => {
  return str.length > maxLength
    ? str.substring(0, Math.ceil((maxLength - 3) / 2)) +
        "..." +
        str.substring(str.length - Math.floor((maxLength - 3) / 2))
    : str;
};

export const Truncator = ({
  children = "",
  maxLength = 0,
  hideCopy = false,
  copyAsLink = false,
  className = "",
}) => {
  const { t } = useTranslation();

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(children);
    toast.success(t("Copied to clipboard"));
  };

  return (
    <span
      className={cx(
        "flex flex-row-reverse lg:flex-row gap-2 items-center",
        copyAsLink && "underline cursor-copy",
        className,
      )}
      onClick={handleCopy}
    >
      {truncate(children, maxLength)}
      {hideCopy || copyAsLink ? null : (
        <Button
          variant="ghost"
          size="icon"
          className="h-5 w-5 opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={handleCopy}
        >
          <Copy className="h-3 w-3 text-muted-foreground" />
        </Button>
      )}
    </span>
  );
};
export default Truncator;
